import { ProductGate } from "./ProductGate";

export function GarlicApp() {
  return <ProductGate appId="garlic" />;
}
